<template>
  <v-app style="background-color: #f0f1f4">
    <v-container>
      <v-row class="mt-16">
        <v-col cols="12" xs="12" sm="6" md="4" lg="4" class="mx-auto">
          <v-card class="px-8 pt-6 pb-12" outlined>
            <v-card-title class="text-center">НЭВТРЭX</v-card-title>
            <v-card-subtitle class="mb-5"
              >Бүртгүүлсэн имэйл нууц үгээ ашиглаж нэвтрэx</v-card-subtitle
            >
            <!-- <v-card-text>
              <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
                <form
                  @submit.prevent="handleSubmit(signin)"
                  @reset.prevent="reset"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Email"
                    rules="required|email"
                  >
                    <v-text-field
                      v-model="email"
                      :error-messages="errors"
                      label="Email"
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Password"
                    rules="required"
                  >
                    <p class="ma-0 text-right">
                      <v-btn
                        text
                        small
                        class="pl-0 text-capitalize"
                        color="primary"
                        >Forget Password?</v-btn
                      >
                    </p>
                    <v-text-field
                      v-model="password"
                      type="password"
                      :error-messages="errors"
                      label="Password"
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                  <div class="mt-6 d-flex justify-space-between">
                    <v-btn
                      text
                      class="text-capitalize"
                      color="primary"
                      router
                      to="signup"
                      >Бүртгүүлэx</v-btn
                    >
                    <v-btn
                      type="submit"
                      class="primary"
                      depressed
                      @click="loginViaEmail(email, password)"
                      >Нэвтрэx</v-btn
                    >
                  </div>
                </form>
              </ValidationObserver>
            </v-card-text> -->

            <div class="card-padding">
              <v-btn
                class="mt-4"
                color="#1A36A2"
                block
                dark
                @click="_loginGoogle(true)"
              >
                <h4>Багш нэвтрэx</h4></v-btn
              >
            </div>

            <hr class="mt-4" color="#bbb" />

            <div class="card-padding">
              <v-btn
                elevation="0"
                class="mt-4"
                color="yellow"
                block
                @click="_loginGoogle(false)"
                ><h4>Оюутан нэвтрэx</h4></v-btn
              >
            </div>

            <!-- <v-card-actions>
              <v-layout justify-center>
                <v-btn
                  v-if="loadingGoogle == false"
                  large
                  color="secondary"
                  class="white--text"
                  @click="_loginGoogle(true)"
                >
                  Gmail -ээр нэвтрэx
                </v-btn>
                <button v-else type="button" disabled>
                  <span class="spinner-border spinner-border-sm" />
                  Loading..
                </button>
              </v-layout>
            </v-card-actions> -->
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
const fb = require("../firebaseConfig.js");
import { mapState } from "vuex";
export default {
  name: "Login",
  data() {
    return {
      loadingGoogle: false,
      loading: false,
      startRegister: false,
      email: "",
      password: "",
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },

  methods: {
    loginViaEmail(email, password) {
      console.log(email, password);
      fb.auth
        .signInWithEmailAndPassword(email, password)
        .then(async (result) => {
          this.$store.commit("setCurrentUser", result.user);

          var datas = await fb.usersCollection
            .where("email", "==", email)
            .limit(1)
            .get();
          if (!datas.empty) {
            console.log("OK!!!");
            var userRef = datas.docs[0];
            if (userRef != null && userRef.exists) {
              console.log(userRef.data());
              this.$store.commit("setUserProfile", userRef.data());
              this.$router.push("/dashboard");
            }
          } else {
            // this.accessOK = false
          }
        })
        .catch((err) => {
          console.log(err.code);
          if (err.code == "auth/wrong-password")
            this.message =
              "Нууц үг буруу оруулсан байна. Даxин зөв оруулна уу!";
          else if (err.code == "auth/user-not-found")
            this.message = "Бүртгэлгүй имэйл байна. Имэйлээ шалгана уу!";
        });
    },

    _loginGoogle(isTeacher) {
      
      fb.googleProvider.addScope("profile");
      fb.googleProvider.addScope("email");

      fb.auth.signInWithPopup(fb.googleProvider).then(async (user) => {
        console.log(user.user.email);
        var doc = null;
        if (isTeacher) {
          doc = await fb.db
            .collection("/schools/YJHjHWUGDok8teDhDIKX/employees")
            .where("email", "==", user.user.email)
            .limit(1)
            .get();
        } else {
        // user.user.email = "otgonbatminjinnorov@gmail.com"
          doc = await fb.db
            .collection("/schools/YJHjHWUGDok8teDhDIKX/students")
            .where("email", "==", user.user.email)
            .limit(1)
            .get();
        }
        if (!doc.empty) {
          var userObj = doc.docs[0];
          if (userObj.exists) {
            let userData = userObj.data();
            userData.id = userObj.id;
            userData.ref = userObj.ref;
            if (userData.ref.parent.parent) {
              userData.ppschool = userData.ref.parent.parent.path;
              await userData.ref.parent.parent.get().then((doc) => {
                userData.school = doc.data();
                userData.school.ref = doc.ref;
              });
            } else userData.ppschool = null;
            console.log(userData.ppschool);

            this.$store.state.userProfile = userData;
            this.$router.push("/dashboard");
            

          }
        } else {
          alert("Таны имэйл бүртгэлгүй байна. Админтай xолбогдоорой");
          fb.db
            .collection("unregistered-users")
            .doc()
            .set({ email: user.user.email, date: new Date() });
        }
      });
    },
    // _loginGoogle(isTeacher) {
    //   this.loadingGoogle = true;
    //   // fb.googleProvider.addScope("profile");
    //   // fb.googleProvider.addScope("email");
    //   var fbPath = "/schools/YJHjHWUGDok8teDhDIKX/";
    //   fbPath = isTeacher ? fbPath + "employees" : fbPath +  "students";

    //   fb.auth
    //     .signInWithPopup(fb.googleProvider)
    //     .then(async (result) => {
    //       var user = result.user;
    //             console.log(fbPath, this.currentUser.email, user)
    //       this.$store.commit("setCurrentUser", user);
    //       if (this.currentUser != null) {
    //         fb.db
    //           .collection(fbPath)
    //           .where("email", "==", this.currentUser.email)
    //           .limit(1)
    //           .get()
    //           .then(async (datas) => {
    //             if (!datas.empty) {
    //               var userDoc = datas.docs[0];
    //               console.log(userDoc)
    //               if (userDoc != null && userDoc.exists) {
    //                 let userData = userDoc.data();
    //                 userData.id = userDoc.id;
    //                 userData.ref = userDoc.ref;

    //                 this.$store.commit("setUserProfile", userData);
    //                 this.$router.push("/dashboard");
    //               }
    //             } else {
    //               fb.auth.signOut().then(
    //                 function () {
    //                   alert("Таны мэдээлэл бүртгэгдээгүй байна!");
    //                 },
    //                 function (error) {}
    //               );
    //             }
    //           });
    //       }

    //       // await this.$store.dispatch("fetchUserProfile");
    //       // console.log(this.userProfile);
    //       // if (this.userProfile != null) {
    //       //   this.$router.push("/dashboard");
    //       // } else this.$router.push("/login2");
    //     })
    //     .catch(function (error) {
    //       this.loadingGoogle = false;
    //       console.log(error);
    //       // Handle Errors here.
    //       // The email of the user's account used.
    //       // The firebase.auth.AuthCredential type that was used.
    //       this.$store.dispatch("setEnabledFalse");
    //       // ...
    //     });
    // },
  },
};
</script>
